export default {
    data() {
        return {
            processing: false
        }
    },
    methods: {
        startCall() {
            this.processing = true;
        },
        endCall() {
            this.processing = false;
        }
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/src/mixins/Processing.js